import React from 'react'
import styled from '@emotion/styled/macro'
import { Theme2, Device } from "../Layout"
import { useCommonItemsQuery } from '../../hooks/use-common-items-query'
import { NavDesktop } from '../NavDesktop'
import { Link } from 'gatsby'
import { Logo, TwentyFourHours } from '../SVGs'

const HeaderDesktopContainer = styled.div`
display: none;
@media ${Device.lg}{
    display: block;
}
position: sticky;
top: 0;
z-index: 3;
background-color: ${Theme2.colors.light};
`

const TopBar = styled.div`
background-color: ${Theme2.colors.dark1};
text-align: center;
padding: 23px 10px;
letter-spacing: 2px;

.pipe{
    margin: 0 1.5em;
}

p{
    text-transform: uppercase;
    font-size: 15px;
    color: ${Theme2.colors.light};

}
.yellowText{
    color: ${Theme2.colors.light2};
}
`
const MiddleBar = styled.div`
background-color: ${Theme2.colors.light};
display: grid;
grid-template-columns: 25% auto auto;
place-items: center;
box-sizing: border-box;
min-height: 148px;
max-width: 1722px;
margin: 0 auto;

svg{
    max-width: 100%;
    box-sizing: border-box;
}
.logo{
   padding: 0 10%;
   width: 100%;
   border-right: 1px solid ${Theme2.colors.neutral};
}
.secondSectionText{
    text-align: center;
    font-weight: 500;
    font-size: 21px;
    font-style: italic;
    padding: 0 5%;
    margin-bottom: 0;

    .redText{
        color: ${Theme2.colors.tertiary};
    }
}
`
const PhoneNumberSection = styled.a`
display: grid;
grid-template-columns: auto auto;
text-decoration: none;
color: ${Theme2.colors.dark1};
align-items: center;
grid-column-gap: 20px;
padding-right: 10%;

.smallerText{
    text-transform: uppercase;
    
    font-weight: 500;
    font-size: 15px;
    color: ${Theme2.colors.dark};
    margin-bottom: 0;
    @media ${Device.xl}{
        font-size: 20px;
    }
}
.largerText{
    
    font-size: 25px;
    font-weight: 700;
    margin-bottom: 0;
    display: inline-block;
    @media ${Device.xl}{
        font-size: 35px;
        margin-top: 10px;
    }
}

`

const HeaderDesktop = () =>{
    const { commonItemsTopBarTextYellow, commonItemsTopBarTextWhite,
        commonItemsHeaderTextBlack,
        commonItemsHeaderTextRed, commonItemsTextAbovePhoneNumberInHeader,
        commonItemsOffices, } = useCommonItemsQuery()
    const tel = "tel:"
    const phoneNumber = commonItemsOffices[0].commonItemsPhone
    const phoneNumberHref = tel+phoneNumber
    return(
        <HeaderDesktopContainer>
        <TopBar>
<p>
    <span className="yellowText">{commonItemsTopBarTextYellow}</span> <span dangerouslySetInnerHTML={{__html: commonItemsTopBarTextWhite}} />
</p>
        </TopBar>
        <MiddleBar>
            <Link to="/">
            <Logo />
            </Link>
<p className="secondSectionText">
    {commonItemsHeaderTextBlack} <span className="redText">{commonItemsHeaderTextRed}</span>
</p>
<PhoneNumberSection href={phoneNumberHref}>
<TwentyFourHours />
<p className="smallerText">
    {commonItemsTextAbovePhoneNumberInHeader}<br />
    <span className="largerText">
    {phoneNumber}
    </span>
    <p>Se hablamos español</p>
</p>

</PhoneNumberSection>
        </MiddleBar>
        <NavDesktop />
        </HeaderDesktopContainer>
    )
}
export default HeaderDesktop